<template>
  <div>
    <div :class="{'firstHalfRow' : spaceneeded === 'halfrowleft',
                  'secondHalfRow' : spaceneeded === 'halfrowright',
                  'allRow' : spaceneeded === 'fullrow'}">
      <div :class="{'firstHalfBlock' : spaceneeded === 'halfrowleft',
                    'secondHalfBlock' : spaceneeded === 'halfrowright'}">
        <input :type="inputType" required="" v-model="inputValue" @input="parseInput" :key="resetKey" class="adaptativePlaceholderBlock" @blur="onBlur"/>
        <label :alt="label" :placeholder="label"></label>
      </div>
    </div>
    <p class="mt-0"><small v-if="hasError" class="d-flex text-danger pl-2">{{ errorMessage }}</small></p>
  </div>
</template>
<script>
/** @author TLV 12/02/2021
* @brief Component for showing input text with an adaptative
*        placeholder : https://codepen.io/dannykingme/pen/IvFuB?editors=1100
*/
export default {
  name: 'AdaptativePlaceholderInput',
  props: {
    errorMessage: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    inputFormating: {
      type: Function,
      default: function (val) {
        return val
      }
    },
    inputType: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number
    },
    onBlur: {
      type: Function,
      default: function () {
      }
    },
    spaceneeded: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      resetKey: false
    }
  },
  methods: {
    parseInput (event) {
      let newValue = this.inputFormating(event.target.value)
      if (newValue === this.inputValue) {
        this.inputValue = newValue
        this.resetKey = !this.resetKey
      } else {
        this.inputValue = newValue
      }
    }
  }
}
</script>
<style lang="less">
// First, pass in the important variables.
.adaptive_placeholder(@height, @radius, @margin: 1.6em, @border: 1px) {
  @borders: (@border * 2); // <- To avoid repeating below
  box-sizing: border-box;  // <- Important for accurate sizing
  width: 100%;             // <- Could be almost anything
  // Anything written inside ~"some_text" will be displayed as some_text after compiling the LESS code to CSS code.
  height: ~"calc(@{height} + @{borders})";
  margin: 0 0 @margin;
  padding: @margin @margin @margin 10px;
  border: @border solid #E8E8E8;
  border-radius: @radius;
  background: #fff;
  resize: none;  // <- For textareas
  outline: none; // <- Because ugly
  //
  // Following block controls all the color change
  //
  &[required] {
    //
    // Following block selects label directly adjacent to input
    //
    &:focus, &:valid {
      + label {
        &[placeholder] {
          &:before {
            transition-duration: .2s;
            //
            // Following lines move placeholder out of the way
            //
            transform: translate(0, (@margin * -1.0)) scale(.9, .9);
            transform-origin: 0 0;
          }
        }
      }
    }
    //
    // Following block injects string from label's 'alt' attr.
    // It comes before the other 'content' property so I can
    // override it. Uses "invalid" pseudo-selector to know
    // when to do that.
    //
    &:invalid {
      + label {
        &[placeholder] {
          &[alt] {
            &:before {
              content: attr(alt); // Content property 1 of 2
            }
          }
        }
      }
    }
    + label {
      &[placeholder] {
        display: block;
        pointer-events: none; // Allows clicking thru label
        line-height: @margin * 1.25;
        // Following pulls label into position
        // margin-top: ~"calc(-@{height} - @{borders})";
        margin-top: ~"calc(-@{height} - @{borders})";
        // Following offsets that above
        margin-bottom: ~"calc((@{height} - @{margin}) + @{borders} - 15px)";
        margin-left: -17px;
        //
        // Following ':before' is needed to switch between
        // different strings.
        //
        &:before {
          content: attr(placeholder); // Content property 2 of 2
          display: inline-block;
          margin: 0 ~"calc(@{margin} + @{borders})";
          padding: 0 2px;
          color: #898989;
          white-space: nowrap;
          transition: .3s ease-in-out;
          //
          // Following lines lets me use solid color as bkg img.
          // This lets me size bkg to something more sublte
          //
          background-image: linear-gradient(to bottom, #fff, #fff);
          background-size: 100% 5px;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
  }
}
//
// Following block is how I call the above function
//
.adaptativePlaceholderBlock {
  @height: 73px;
  &[type="text"] {
    .adaptive_placeholder(@height, 5px);
  }
}
</style>



// WEBPACK FOOTER //
// AdaptativePlaceholderInput.vue?93aa0e40